/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useContext, useRef, useState } from 'react';
import Paper from '@material-ui/core/Paper';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import { Box, fade } from '@material-ui/core';
import DateNavigatorReports from '../../components/filters/DateNavigatorReports';
import { bgimage } from '../constants';
import PageLayout from '../shared/PageLayout';
import PopupFormOperationView from '../shared/PopupFormOperationView';
import TabsList from '../components/TabsList';
import useCompany from '../../hooks/useCompany';
import useAccounts from '../../hooks/useAccounts';
import ReceiptAdvance from './ReceiptAdvance';
import PaymentAdvance from './PaymentAdvance';
import Finance from './Finance';
import FinanceAllKaid from './FinanceAllKaid';
import Accounts from '../shared/Accounts';
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from 'react-router-dom';
import { FinanceContext } from '../../contexts';
import FinanceBalances from './FinanceBalances';

export default function FinanceOperations({
  isRTL,
  words,
  user,
  theme,
  menuitem,
  formgroup,
  drawerWidth,
}: any) {
  const [start, setStart] = useState<any>(null);
  const [end, setEnd] = useState<any>(null);

  const [item, setItem] = useState(null);
  const [openItem, setOpenItem] = useState(false);

  const receiptref: any = useRef();
  const paymentref: any = useRef();
  const financeref: any = useRef();
  const kaidref: any = useRef();
  const balanceref: any = useRef();
  const accountref: any = useRef();

  const { pathname } = useLocation();
  const navigate = useNavigate();

  const { height, width } = useWindowDimensions();
  const { company } = useCompany();
  const { accounts } = useAccounts();

  const {
    state: { currentDate, currentViewName, endDate, pageSize },
    dispatch,
  } = useContext(FinanceContext);

  const setPageSize = (pageSize: any) => {
    dispatch({ type: 'setPageSize', payload: pageSize });
  };

  const currentViewNameChange = (e: any) => {
    dispatch({ type: 'setCurrentViewName', payload: e.target.value });
  };
  const currentDateChange = (curDate: any) => {
    dispatch({ type: 'setCurrentDate', payload: curDate });
  };

  const endDateChange = (curDate: any) => {
    dispatch({ type: 'setEndDate', payload: curDate });
  };

  const onCloseItem = () => {
    setOpenItem(false);
    setItem(null);
  };

  const handleSelect = (item: any) => {
    navigate(item?.path);
  };

  const refresh = () => {
    if (pathname?.includes('transfer')) {
      financeref?.current?.refresh();
    }
    if (pathname?.includes('adpayment')) {
      paymentref?.current?.refresh();
    }
    if (pathname?.includes('adreceipt')) {
      receiptref?.current?.refresh();
    }
    if (pathname?.includes('entry')) {
      kaidref?.current?.refresh();
    }
    if (pathname?.includes('balances')) {
      balanceref?.current?.refresh();
    }
    if (pathname?.includes('accounts')) {
      accountref?.current?.refresh();
    }
  };

  const bgcolor = '#ae2ae212';
  // transfer
  // adpayment
  // adreceipt
  // entry
  // accounts
  return (
    <PageLayout
      menuitem={menuitem}
      isRTL={isRTL}
      words={words}
      theme={theme}
      refresh={refresh}
      bgcolor={bgcolor}
      bgimage={bgimage}
      width={width - drawerWidth}
    >
      <Box
        style={{
          height: height - 50,
          overflow: 'auto',
        }}
      >
        <Box
          display="flex"
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            marginRight: 50,
            marginLeft: 50,
            marginTop: 5,
          }}
        >
          <DateNavigatorReports
            setStart={setStart}
            setEnd={setEnd}
            currentDate={currentDate}
            currentDateChange={currentDateChange}
            currentViewName={currentViewName}
            currentViewNameChange={currentViewNameChange}
            endDate={endDate}
            endDateChange={endDateChange}
            views={[1, 7, 30, 365, 1000]}
            isRTL={isRTL}
            words={words}
            theme={theme}
          ></DateNavigatorReports>
        </Box>
        <Paper
          elevation={5}
          style={{
            borderRadius: 25,
            margin: 25,
            marginTop: 5,
            width: width - drawerWidth - 50,
            height: height - 135,
          }}
        >
          <TabsList
            handleSelect={handleSelect}
            isRTL={isRTL}
            list={formgroup}
            theme={theme}
            width={width - drawerWidth - 50}
            color={fade(theme?.palette?.secondary?.main, 0.2)}
            pathname={pathname}
          ></TabsList>
          <Paper
            style={{
              display: 'flex',
              height: height - 185,
              overflow: 'auto',
              borderBottomLeftRadius: 25,
              borderBottomRightRadius: 25,
            }}
          >
            <Routes>
              <Route
                index
                element={<Navigate to={formgroup?.[0]?.path} replace />}
              />
              <Route
                path={'transfer'}
                element={
                  <Finance
                    ref={financeref}
                    start={start}
                    end={end}
                    isRTL={isRTL}
                    words={words}
                    theme={theme}
                  ></Finance>
                }
              />
              <Route
                path={'adpayment'}
                element={
                  <PaymentAdvance
                    ref={paymentref}
                    start={start}
                    end={end}
                    isRTL={isRTL}
                    words={words}
                    theme={theme}
                    company={company}
                    drawerWidth={drawerWidth}
                  ></PaymentAdvance>
                }
              />
              <Route
                path={'adreceipt'}
                element={
                  <ReceiptAdvance
                    ref={receiptref}
                    start={start}
                    end={end}
                    isRTL={isRTL}
                    words={words}
                    theme={theme}
                    company={company}
                    drawerWidth={drawerWidth}
                  ></ReceiptAdvance>
                }
              />
              <Route
                path={'entry'}
                element={
                  <FinanceAllKaid
                    ref={kaidref}
                    start={start}
                    end={end}
                    isRTL={isRTL}
                    words={words}
                    theme={theme}
                    company={company}
                  ></FinanceAllKaid>
                }
              />
              <Route
                path={'balances'}
                element={
                  <FinanceBalances
                    ref={balanceref}
                    start={start}
                    end={end}
                    isRTL={isRTL}
                    words={words}
                    theme={theme}
                    company={company}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                  ></FinanceBalances>
                }
              />
              <Route
                path={'accounts'}
                element={
                  <Accounts
                    isRTL={isRTL}
                    ref={accountref}
                    accounts={accounts}
                  ></Accounts>
                }
              />
            </Routes>
          </Paper>
        </Paper>
        <PopupFormOperationView
          open={openItem}
          onClose={onCloseItem}
          row={item}
          theme={theme}
          isRTL={isRTL}
          words={words}
          user={user}
        ></PopupFormOperationView>
      </Box>
    </PageLayout>
  );
}
